import React, { useState, useMemo, useContext, useReducer } from 'react';
import { TranslationContext } from "../hooks/useTranslationContext";
import 'url-search-params-polyfill';

import Calendar from "react-range-calendar";

import dayjs from 'dayjs';
import {
    ReportDateContext,
    useReportDateContext
} from "../hooks/ReportDateContext";

export const useDateFrame = (initialTitle) => {
    const isBrowser = typeof window !== 'undefined';
    const [ pickingTime, setPickingTime ] = useState(false);
    const { dispatch, state, reportId, isThreshold, title } = useReportDateContext();
    const t = useContext(TranslationContext);

    const CalendarInstance = useMemo(() => (
        isBrowser ?
        <Calendar
            style={{margin:"auto"}}
            visible={pickingTime}
            steps={7}
            startWithDay={"Mon"}
            dateRange={[ state.startDate, state.endDate ]}
            onDateClick={
                (startDate, endDate) => dispatch(
                    {
                        startDate,
                        endDate,
                        sliceSecs: state.sliceSecs
                    })
            }
            type="free-range"
        /> : null
    ), [ pickingTime, state.startDate, state.endDate]);


    const printButton = useMemo(() => (
        <button className="btn" onClick={function() { window.print(); }}>{t('reporting.button_print')}</button>
    ), []);
    const timeFrameButton = useMemo(() => (
        <button className="btn" onClick={ () => setPickingTime(!pickingTime) }>{ t("reporting.select_time_frame") }</button>
        ), [ pickingTime, t ]);
    const sliceSizeCb = (ev) => {
        const newVal = +ev.target.value;
        dispatch({
            startDate: state.startDate,
            endDate: state.endDate,
            sliceSecs: newVal
        });
    }
    const sliceSizeSelect = (
        <div className="form-group inline-form-block">
            <select value={ state.sliceSecs } className="form-select" onChange={ sliceSizeCb }>
                <option value={3600}>{ t('reporting.time_unit_hourly') }</option>
                <option value={86400}>{ t('reporting.time_unit_daily') }</option>
            </select>
        </div>
    );

    return {
        ...state,
        pickingTime,
        reportId,
        isThreshold,
        title,
        printButton,
        timeFrameButton,
        sliceSizeSelect,
        calendar: CalendarInstance
    };
}